import Vue from "vue";

const filters = () => {
	Vue.filter("dateFormat", (date) => {
		if (!date) return null;
		const [ year, month, day ] = date.split("-");
		return `${ month }/${ day }/${ year }`;
	});

	Vue.filter("toLowerCase", (value) => {
		if (!value) return null;
		return value.toLowerCase();
	});
};

export default filters;
